import { RiDownloadCloudLine } from "@remixicon/react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import useApi from "../../hooks/useGaneshApi";

interface DownloadDeliveryExportProps {
  s3Uri: string;
}

const DownloadS3URIButton: React.FC<DownloadDeliveryExportProps> = ({
  s3Uri,
}) => {
  const [loadingFileInfo, setLoadingFileInfo] = useState<boolean>(true);
  const [loadingFileBlob, setLoadingFileBlob] = useState<boolean>(false);
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [fileName, setFileName] = useState<string>("");
  const [presignedUrl, setPresignedUrl] = useState<string | null>(null);
  const [s3FileSize, setS3FileSize] = useState<string | null>(null);

  const { apiRequest } = useApi();

  const handleClickOpenDownloadModal = async (s3_uri: string) => {
    setLoadingFileBlob(false);
    setDownloadDialogOpen(true);
    setLoadingFileInfo(true);

    const params = new URLSearchParams({ s3_uri: s3_uri });
    const response = await apiRequest<any>(
      `/get_presigned_url?${params.toString()}`,
      { method: "GET" }
    );
    if (!response.data) {
      throw new Error(`Failed to fetch presigned url for ${s3_uri}`);
    } else {
      setPresignedUrl(response.data.presigned_url);
      setS3FileSize(response.data.file_size);
    }
    setFileName(s3_uri.split("/").pop()?.replace(".gz", "") || "file");
    setLoadingFileInfo(false);
  };

  const handleCloseDownloadModal = () => {
    setDownloadDialogOpen(false);
    setS3FileSize(null);
    setFileName("");
  };
  const toDataURL = async (url: string) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };
  const handleDownloadS3Export = async () => {
    try {
      setLoadingFileBlob(true);
      if (presignedUrl) {
        const link = document.createElement("a");
        link.href = await toDataURL(presignedUrl);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        handleCloseDownloadModal();
      }
    } catch (error) {
      console.error("Download error", error);
    } finally {
      setLoadingFileBlob(false);
    }
  };

  return (
    <>
      <IconButton onClick={() => handleClickOpenDownloadModal(s3Uri)}>
        <RiDownloadCloudLine />
      </IconButton>
      <Dialog open={downloadDialogOpen} onClose={handleCloseDownloadModal}>
        <DialogTitle>Download File</DialogTitle>
        {loadingFileInfo ? (
          <Box>
            <DialogContent>
              <p>Getting file info...</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDownloadModal} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </Box>
        ) : loadingFileBlob ? (
          <Box>
            <DialogContent>
              <p>Please wait while I fetch and decompress this file...</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDownloadModal} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </Box>
        ) : (
          <Box>
            <DialogContent>
              <p>
                Are you sure you want to download this file
                {s3FileSize ? ` (${s3FileSize} compressed)` : ""}?
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDownloadModal} color="primary">
                Cancel
              </Button>
              <Button onClick={handleDownloadS3Export} color="primary">
                Download
              </Button>
            </DialogActions>
          </Box>
        )}
      </Dialog>
    </>
  );
};

export default DownloadS3URIButton;
